import React from 'react'
import { Text, TextTypes, Fonts, TextSize, Weight } from 'components'
import { GLOBAL_COLORS } from 'theme'
import { formatNumberAsTicker } from './formatters'
import { ColoredTriangle, Wrapper } from './styled'

export type NumberStyleTypes = 'percent' | 'dollar' | 'none'

interface Props {
  className?: string
  children?: JSX.Element
  processedValue: number
  formatter?: (processedValue: number, isPositive: boolean, isSymbol: boolean) => string
  fontWeight?: Weight
  suffix?: string
  prefix?: string
  textType?: TextTypes
  fontType?: Fonts
  isSymbol?: boolean
  isTriangle?: boolean
  type?: NumberStyleTypes
}

/**
 * @example 
  import { PolarityNumber } from 'components'
  <PolarityNumber processedValue={33.78964}/>  

* IoC number formatter, provide your own or use the defaults:
* @see formatNumberAsTicker - for ticker formatting 
* @see formatNumberAsCurrency - for currency formatting
*/

export const PolarityNumber: React.FC<Props> = ({
  processedValue = 0,
  textType = 'small',
  isSymbol = false,
  isTriangle = false,
  suffix = '',
  prefix = '',
  fontWeight,
  className,
  formatter = formatNumberAsTicker,
}) => {
  const isPositive: boolean = processedValue >= 0 ? true : false
  const computedColor = isPositive ? GLOBAL_COLORS.secondaryGreen : GLOBAL_COLORS.volcanoRed

  return (
    <Wrapper className={className}>
      <Text weight={fontWeight} type={textType} color={computedColor}>
        {prefix && prefix}
        {formatter(processedValue, isPositive, isSymbol)}
        {suffix && suffix}
      </Text>
      {isTriangle && <ColoredTriangle isPositive={isPositive} size={TextSize[textType]} />}
    </Wrapper>
  )
}
